// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"jY-z","sponsoredTooltipWrapper":"kY-z","sponsoredTooltip":"lY-z","newCard":"mY-z"};